import React from "react";
import { HeroBlock } from "../HeroBlock/HeroBlock";
import { FrontPageType } from "../../types/optimizely/frontpage";
import { getButtonVariant } from "../../utils/getButtonVariant";
import Link from "../Link/Link";

export const HeroContainer = ({ content }: { content: FrontPageType }) => {
  const backgroundImage = content.listImage?.expandedValue?.url;
  const title = content?.title?.value || "";
  const subTitle = content?.mainIntro?.value || "";
  const videoUrl = content?.videoUrl?.value || "";
  const backgroundColor = content.introBackgroundColor?.value;
  const fontColor = content.introFontColor?.value;
  const ctaButtons = content.callToActionButtons?.expandedValue;

  return (
    <HeroBlock
      backgroundImage={backgroundImage}
      title={title}
      subTitle={subTitle}
      videoUrl={videoUrl}
      backgroundColor={backgroundColor}
      fontColor={fontColor}
      actions={ctaButtons?.map((button, index) => (
        <Link
          key={`${button.linkText}${index}`}
          variant={getButtonVariant(button.buttonType.value)}
          text={button.linkText.value}
          href={button.buttonLink.value}
        />
      ))}
    />
  );
};
